import {
  Box,
  Center,
  Text,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

export default function Background() {
  return (
    <>
      <LineSection />
      <Box
        color='white'
      >
        <Center>
          <Box
            w={{ base: "full", md: "4xl", xl: "8xl" }}
            pt={{ base: 10 }}
          >
            <SectionHeading
              title="Background"
              align={"center"}
            />
          </Box>
        </Center>

        <Box className="opacityBottom">
          <Center>
            <Box
              w={{ base: "xl", md: "4xl", xl: "6xl" }}
            >
              <Text
                pt={10}
                pb={10}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              >
                <Lang text="At AppOX, we firmly believe that small businesses form the bedrock of the complex economic fabric, a truth that is even more relevant in low-income countries." />
              </Text>

              <Text
                pb={{ base: 20, md: 40 }}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              >
                <Lang text="Our mission is to collaborate closely with these small businesses to drive their economic growth through the improvements that AI can offer. We strongly believe that the economic progress of businesses directly translates to an enhancement in the quality of life for their employees." />
              </Text>

            </Box>
          </Center>
        </Box>
      </Box>
    </>
  );
}